export const environment = {
    production: true,
    environmentName: "Live",

    gcConnectorUrl: "https://greencommerce-connector.azurewebsites.net/api/",
    identityServerUrl: "https://jemid-identityserver.azurewebsites.net",
    appUrl: "https://connector-portal.greencommerce.nl",
    clientId: "381b892e-47c0-4b8f-8fca-fedcd3af0ac9",
};
